import React, { useState, useEffect } from "react";
import "./App.css";

const Countdown = () => {
  const [countdown, setCountdown] = useState("");
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const targetDate = new Date("January 1, 2026 00:00:00");
      const startDate = new Date("December 25, 1999 00:00:00");
      const now = new Date().getTime();
      const distanceTotal = targetDate - startDate;
      const distanceRemaining = targetDate - now;
      const percentage =
        ((distanceTotal - distanceRemaining) / distanceTotal) * 100;

      const days = Math.floor(distanceRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distanceRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distanceRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((distanceRemaining % (1000 * 60)) / 1000);

      setCountdown(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      setPercentage(percentage.toFixed(3));

      if (distanceRemaining < 0) {
        clearInterval(interval);
        setCountdown("EXPIRED");
        setPercentage(100);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="countdown-container">
      <div className="countdown-text">Countdown to January 1, 2026:</div>
      <div className="countdown">{countdown}</div>
      <div className="percentage">{percentage}% completed</div>
    </div>
  );
};

const DaysTable = () => {
  const [daysPassed, setDaysPassed] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const startDate = new Date("January 1, 2025");
      const daysSinceStart = Math.floor(
        (now - startDate) / (1000 * 60 * 60 * 24)
      );
      setDaysPassed(Math.max(0, daysSinceStart));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const getDateForDay = (dayNumber) => {
    const startDate = new Date("January 1, 2025");
    const date = new Date(startDate);
    date.setDate(date.getDate() + (dayNumber - 1));
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };

  const getMonthForDay = (dayNumber) => {
    const startDate = new Date("January 1, 2025");
    const date = new Date(startDate);
    date.setDate(date.getDate() + (dayNumber - 1));
    return date.toLocaleDateString("en-US", { month: "long" });
  };

  const totalDays = 365;
  const rows = [];
  const daysPerRow = 7;
  let currentMonth = "";

  for (let i = 0; i < totalDays; i += daysPerRow) {
    const rowDays = [];
    let showRow = false;

    for (let j = 0; j < daysPerRow && i + j < totalDays; j++) {
      const dayNumber = i + j + 1;
      const month = getMonthForDay(dayNumber);
      if (month !== currentMonth) {
        currentMonth = month;
      }
      if (dayNumber > daysPassed) {
        showRow = true;
      }
    }

    if (showRow) {
      for (let j = 0; j < daysPerRow && i + j < totalDays; j++) {
        const dayNumber = i + j + 1;
        const isPassed = dayNumber <= daysPassed + 1;
        const dateStr = getDateForDay(dayNumber);

        rowDays.push(
          <td
            key={dayNumber}
            className={`day-cell ${isPassed ? "passed" : ""}`}
          >
            <div className="day-number">{dayNumber}</div>
            <div className="day-date">{dateStr}</div>
            {isPassed && <span className="cross">×</span>}
          </td>
        );
      }
      rows.push(<tr key={i}>{rowDays}</tr>);
    }
  }

  return (
    <div className="table-container">
      {/* <h2>Days Remaining in 2025</h2> */}
      <table className="days-table">
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

const App = () => {
  return (
    <div className="app-container">
      <Countdown />
      <DaysTable />
    </div>
  );
};

export default App;
